// Shared definitions for the "best time to arrive for a [HH] flight" SEO
// archetype. Imported by the page template, the hub, and the sitemap so the
// departure-hour range AND the thin-content indexability rule live in exactly
// one place (the page's noindex decision and the sitemap's inclusion decision
// must never drift apart).

// Departure hours we generate a page for (CPH's realistic departure window).
// Zero-padded strings double as the URL slug, e.g. /best-time-to-arrive/06.
export const DEPARTURE_HOURS = Array.from({ length: 18 }, (_, i) => i + 5); // 05..22

// CPH guidance: be through security ~2h before a short-haul/Schengen departure.
// We key the security-crowding lookup to that arrival window.
export const LEAD_HOURS = 2;

export const pad = (h) => String(h).padStart(2, '0');
export const formatHour = (h) => `${pad(h)}:00`;
export const hourSlugs = () => DEPARTURE_HOURS.map(pad);

// The recommended "be through security by" hour for a given departure hour.
export const arrivalHourFor = (depHour) => Math.max(0, depHour - LEAD_HOURS);

// Build a Map(hour -> avgLow|null) from a getHourlyWaitAverages() result.
export const byHourMap = (hourly) =>
    new Map((hourly || []).map((h) => [h.hour, h.avgLow]));

// Average wait at the arrival window for a departure hour, or null if we have
// no data for that hour. This is the single source of truth for the page's
// factual claim, its noindex flag, and its sitemap inclusion.
export const arrivalAvgFor = (depHour, byHour) => {
    const h = arrivalHourFor(depHour);
    return byHour.has(h) && byHour.get(h) != null ? byHour.get(h) : null;
};

// Thin-content guard: an hour is indexable only when its arrival window has a
// real average wait to ground the page.
export const isHourIndexable = (depHour, byHour) =>
    arrivalAvgFor(depHour, byHour) != null;
